import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_DOCUMENT} from '../../constants';

export default {
  id: 'DEPOT_DOC',
  title: 'Come posso depositare o aggiornare un documento?',
  description: '',
  categories: [CONTENT_CATEGORY_DOCUMENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Fare clic sul pulsante «Depositare» a destra del documento'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_DEPOT_DOC/IT_DEPOT_DOC_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Quindi, trascinare o trascinare il documento al centro dell\'area'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_DEPOT_DOC/IT_DEPOT_DOC_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Immettere i campi e quindi validare'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_DEPOT_DOC/IT_DEPOT_DOC_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Il documento passa allo stato «In attesa di verifica». Ogni documento viene autenticato e convalidato dai nostri team.'
  }]
};
